import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {

@Input('hasLegend') hasLegend = 'true'
@Input('chartType') chartType = 'pie'
@Input('chartData') chartData = [
  { 
    data: []
  },
];
@Input('chartLabels') chartLabels  = [];

//Define Default Colors
myColors = [
  {
    backgroundColor: [
      "#F7464A",
      "#46BFBD",
      "#FDB45C",
      "#949FB1",
      "#F8272C",
      "#3e95cd", 
      "#8e5ea2",
      "#3cba9f",
      "#e8c3b9",
      "#c45850",
      "#F7464A",
      "#46BFBD",
      "#FDB45C",
      "#949FB1",
      "#F8272C",
      "#3e95cd", 
      "#8e5ea2",
      "#3cba9f",
      "#e8c3b9",
      "#c45850"
    ]    
  }
];

  chartOptions = {
    legend: {position: 'bottom'},
    responsive: true,
    tooltips: {
      callbacks: {
      label: function(tooltipItem, data) {
            const dslabels = data.labels[tooltipItem.index];
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const dslabelamt = dataset.data[tooltipItem.index];
            return dslabels + ': ' + dslabelamt +'%';
            }
        }
   },
   elements: {
    arc: {
      borderWidth: 0
    }
  }
  };


  onChartClick(event) {
    console.log(event);
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/chart/chart.component.ts